<template>
  <div>
    <div class="d-flex flex-column">
      <SectionTitle :label="`${$t('label.reviews')} (${totalReviews})`" />
      <div class="d-flex flex-row">
        <Rating v-if="totalReviews" :value="rateNumber" class="ml-lg-4" large dense customStar />
        <span v-if="totalReviews" class="mt-1 ml-1">{{ rateNumber }}</span>
      </div>
    </div>
    <div class="d-flex flex-wrap mb-7">
      <FilterButton v-model="currentFilter" v-for="filter in availableFilters" :key="filter.label" :label="filter.label" :filter="filter.filter" />
    </div>
    <ProductReview v-for="review in reviews" :review="review" :key="review.review" />
  </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import FilterButton from '@/components/product/FilterButton.vue'
import ProductReview from '@/components/product/ProductReview.vue'
import Rating from '@/components/Rating.vue'
import { localeHelper } from '@/utils'
import { REVIEW } from '@/api'

export default {
  components: { SectionTitle, FilterButton, ProductReview, Rating },
  props: {
    productId: { required: true }
  },

  data() {
    return {
      availableFilters: [
        { label: localeHelper.getMessage('button.all'), filter: 'none', api_filter: 1 },
        { label: localeHelper.getMessage('button.imageAndVideo'), filter: 'with_media', api_filter: 2 },
        { label: localeHelper.getMessage('button.ratingHighToLow'), filter: 'rating_desc' },
        { label: localeHelper.getMessage('button.ratingLowToHigh'), filter: 'rating_asc' }
      ],
      currentFilter: 'none',
      totalReviews: '',
      rateNumber: '',
      reviews: []
    }
  },
  created() {
    REVIEW.getReviewList({ type: 1, item_id: this.productId, filter: 1 }).then((res) => {
      this.totalReviews = res.total_reviews
      this.rateNumber = res.rate_number
      this.reviews = res.review
    })
  },
  watch: {
    currentFilter() {
      const selectedFilter = this.availableFilters.find((item) => item.filter == this.currentFilter)

      if (selectedFilter.api_filter) {
        REVIEW.getReviewList({ type: 1, item_id: this.productId, filter: selectedFilter.api_filter }).then((res) => {
          this.reviews = res.review
        })
      } else {
        const asc = selectedFilter.filter === 'rating_asc'
        this.sortReview(asc)
      }
    }
  },
  methods: {
    sortReview(asc) {
      this.reviews.sort((a, b) => {
        if (asc) {
          return a.star - b.star
        } else {
          return b.star - a.star
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-border {
  border: 1px solid var(--v-light-green-base) !important;
}
</style>
